import { useQuery } from '@tanstack/react-query';

import { CustomerInfoResponse } from '@/api/customers/types';
import { RequestOptions, axios } from '@/common/axios';
import { QueryConfig } from '@/common/react-query';
import { STRIPE_CURRENT_CUSTOMER_INFO_QUERY_KEY } from '@/config';

export const getCustomerInfo = async (options?: RequestOptions): Promise<CustomerInfoResponse> => {
    return axios.get<CustomerInfoResponse, CustomerInfoResponse>('/api/v2/customers/me', options);
};

type UseSubsciptionsInfoOptions = {
    config?: QueryConfig<typeof getCustomerInfo>;
};

export const useCustomerInfo = ({ config }: UseSubsciptionsInfoOptions = {}) => {
    return useQuery<CustomerInfoResponse>({
        ...config,
        queryKey: [STRIPE_CURRENT_CUSTOMER_INFO_QUERY_KEY],
        queryFn: ({ signal }) => getCustomerInfo({ signal }),
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
